/**
 * Author: ligj@mapbar.com
 * Create Time: 2018/01/09 16:41
 * Description:
 */
import {
    TAB_VIEW_REMOVE,
    TAB_VIEW_SET_TITLE,
    TAB_VIEW_CLOSE_CURRENT,
    TAB_VIEW_CLOSE_ALL,
    TAB_VIEW_CLOSE_PAGES,
    SET_PAGE_ACTIVENAME
} from '../store/mutations';
import Vue from "vue";
import app from '../../views/App'

const UPDATE_PAGE = 'UPDATE_PAGE_TAB_VIEW';

Object.defineProperty(Vue.prototype, '$page', {
    get() {
        let $this = this;
        return {
            /**
             * 关闭当前打开的tab页
             * @param isForceClose [Boolean] 是否强制关闭页面，默认false
             */
            closeCurrent: (isForceClose = false) => {
                this.$store.commit(TAB_VIEW_CLOSE_CURRENT);
                this.$fire(UPDATE_PAGE, isForceClose);
            },
            /**
             * 关闭所有页面
             * @param forceClosePages [Array<String>|String] 强制关闭的页面name
             */
            closeAll: (forceClosePages = []) => {
                this.$store.commit(TAB_VIEW_CLOSE_ALL, forceClosePages);
                this.$fire(UPDATE_PAGE);
            },
            /**
             * 关闭指定页面
             * @param closePages [Array<String>|String] 需要关闭的页面name，不区分是否强制关闭
             */
            closePages: (closePages = []) => {
                this.$store.commit(TAB_VIEW_CLOSE_PAGES, closePages);
                this.$fire(UPDATE_PAGE);
            },
            set title(val) {
                $this.$nextTick(() => {
                    $this.$store.commit(TAB_VIEW_SET_TITLE, { key: $this.$route.query['_'], title: val });
                });
            }
        }
    }
});

// Vue.mixin({
//     methods: {
//
//     }
// });

/**
 *
 * 1、 读取 url参数时，使用vm.$state  替换 vm.$route
 * 2、 在modal内部关闭modal，调用vm.$modal.close()
 */
export default {
    name: 'tab-views',
    data() {
        return {
            // activeName:'ClassificationStatistics'
            contextmenuTop: 0,
            contextmenuLeft: 0,
            contextmenuRight: 2,
            disabledList: []//['UseDetail','MenuDetail','ServerList','Integration','IntegrationHome','BuildDetail','BuildLog','ParamsBuild','PrevBuild']
        }
    },
    mounted() {
        this.$bind(UPDATE_PAGE, () => {
            this.pushPage();
        });
        //this.initEvent();
    },
    methods: {
        pushPage(idx) {
            // console.log(this.pages);
            idx = typeof idx === 'number' ? idx : this.pages.findIndex(item => item.query['_'] == this.activeName);
            if (idx > -1) {
                // this.$store.commit('TAB_VIEW_ENABLED',true)
                // console.log(this.pages[idx]);
                // this.activeName=this.pages[idx].query['_']
                this.$store.commit(SET_PAGE_ACTIVENAME,this.pages[idx].query['_'])
                // console.log(this.activeName);
                // console.log(this.pages[idx].fullPath);
                this.$router.push({ path: this.pages[idx].fullPath, query: this.pages[idx].query });
            }
        },
        tabSelect(tab) {
            this.pushPage(+tab.index);
        },
        tabClose(tabName) {
            this.$store.commit(TAB_VIEW_REMOVE, { query: { '_': tabName } });
            this.pushPage();
        },
        tabCloseAll() {
            // console.log(this.pages);
            // let idx=this.pages.findIndex(item=>)
            this.$store.commit(TAB_VIEW_CLOSE_ALL, this.pages);
            this.$fire(UPDATE_PAGE);
        },
        tabCloseOther(tabName) {
            // this.pushPage();
            // console.log(tabName);
            var forceClosePages = this.pages.filter(item => item.query['_'] && item.query['_'] !== tabName&&item.query['_']!=='u3a6tQgmRDMi+sUKPbtZTw==');
            forceClosePages.map(item => this.tabClose(item.query['_']));
        },
        closeTab(){
            this.tabCloseOther(this.activeName);
        },
        tabUpdateCurrent(idx){
            // let vm= this
            // console.log(this.$root);
            // app.methods.reload(vm)
            // this.$root.reload()
            idx = typeof idx === 'number' ? idx : this.pages.findIndex(item => item.query['_'] == this.activeName);
            if (idx > -1) {
                // console.log('lalala');
                // console.log(this.pages[idx]);
                // console.log(this.pages[idx].fullPath);
                this.$router.push({ path:'/redirect', query:{
                    url:`${this.pages[idx].fullPath }`}
                    })
                // this.pushPage();//一会去掉试试
            }

        },
        // 右键菜单事件处理
        rightCommand(command) {
            switch (command) {
                case 'closeCurrentPage':
                    this.tabClose(this.activeName);
                    break;
                case 'closeAllPage':
                    this.tabCloseAll();
                    break;
                case 'closeOuterPage':
                    this.tabCloseOther(this.activeName);
                    break;
                case 'updateCurrentPage':
                    this.tabUpdateCurrent()
                default:
                    break;
            }
        },
        initEvent() {
            var self = this;
            // 取消右键默认信息
            this.$refs['tabs'].$el.oncontextmenu = function (event) {
                event = event || window.event;
                event.preventDefault();
                // 判断点击的是否为tab-item
                if (/el-tabs__item/.test(event.target.className)) {
                    // trigger兼容处理
                    if (document.all) {
                        event.target.click();
                    } else {
                        var evt = document.createEvent("Events");
                        evt.initEvent('click', true, true);
                        event.target.dispatchEvent(evt);
                    };
                    // 下拉菜单位置刷新
                    self.contextmenuTop = event.clientY;
                    self.contextmenuLeft = event.clientX;
                    // 为什么加个定时器就好用了？ 这里要延时超过下拉框动画收起的时间才行；
                    setTimeout(() => self.$refs['tabsContentmenu'].show(), 250)
                }
            }
        }
    },
    computed: {
        pages() {
            return this.$store.state.tabView.pages;
        },
        activeName:{
            get:function () {
                return this.$store.state.tabView.currentPage + '';
            },
            set:function(newVal){
                this.$store.state.tabView.currentPage=newVal+''
            }


        }
    },
    watch: {
        pages: {
            deep: true,
            handler(newval) {
                let disabledList = this.disabledList
                let filterArr = disabledList.filter(item => newval[newval.length-1].name === item)
                if (filterArr.length) {
                    this.$store.commit('TAB_VIEW_SHIFT')
                }
            }
        }
    },
    render() {
        return  <div class="tab-wrap" style="user-select: none;">
                    <div class="tab-container">
                        <el-tabs class="tab-view-pages"
                        ref="tabs"
                        value={this.activeName}
                        on-tab-remove={this.tabClose.bind(this)}
                        on-tab-click={this.tabSelect.bind(this)}
                        type={'card'} closable={false}>
                            {
                                this.$store.state.tabView.pages.map((item,idx) => {
                                    let closable = item.meta.closable === false? false : true;
                                    return <el-tab-pane key={item.fullPath} closable={closable} label={item.title || item.meta.title || item.name} name={item.query['_']}>{this.activeName}</el-tab-pane>
                                 })
                            }
                        </el-tabs>
            </div>
            <el-dropdown
        on-command={this.rightCommand.bind(this)}
        ref="tabsContentmenu"
        style={{
            // position: 'absolute',
            //     top: this.contextmenuTop + 'px',
            //     right: this.contextmenuRight + '%',
            //     fontSize:'20px',
            //     width:'20px',
            //     height:'34px',
            //     display:'inline-block',
            //     backgroundColor:'#EAECF3',
            //     paddingRight:'11px',
            //     borderRadius:'0 6px 6px 0',
        }}>
    <span class="el-dropdown-link tab-colse flex flex-center" style="opacity:1;" >
            <i class="el-icon-arrow-down el-icon--right" style="fontSize:20px"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="updateCurrentPage">刷新当前页</el-dropdown-item>
            <el-dropdown-item command="closeOuterPage">关闭其他页</el-dropdown-item>
            <el-dropdown-item command="closeAllPage" style={this.activeName=="u3a6tQgmRDMi+sUKPbtZTw=="?"display:none":"display:block"}>关闭所有页</el-dropdown-item>

            </el-dropdown-menu>
            </el-dropdown>
        {
            /*<div class="tab-colse flex flex-center"  onClick={this.closeTab.bind()}>
            <span class="el-icon-circle-close-outline" title="关闭其他"></span>
            </div>*/
        }
        </div>
    }
};
